import random from 'lodash/random';
export const _random = random;
